import React, { type FC } from 'react'

import { AddressIcon } from './AddressIcon'
import classes from './AddressBadge.module.scss'

type AddressBadgeProps = {
  address?: string
}

export const AddressBadge: FC<AddressBadgeProps> = ({ address }) => {
  return (
    <div className={classes.Container}>
      <AddressIcon />
      {address && <span>{address}</span>}
    </div>
  )
}
